export const TournamentTypes = {
	FETCH_TOURNAMENT_RESULTS: 'FETCH_TOURNAMENT_RESULTS',
	SET_TOURNAMENT_RESULTS: 'SET_TOURNAMENT_RESULTS',
	FETCH_TOURNAMENT_DETAILS: 'FETCH_TOURNAMENT_DETAILS',
	SET_TOURNAMENT_DETAILS: 'SET_TOURNAMENT_DETAILS',
	FETCH_TOURNAMENT_URL: 'FETCH_TOURNAMENT_URL',
	SET_TOURNAMENT_URL: 'SET_TOURNAMENT_URL',
	FETCH_TOURNAMENT_PREVIEW: 'FETCH_TOURNAMENT_PREVIEW',
	SET_TOURNAMENT_PREVIEW: 'SET_TOURNAMENT_PREVIEW'
}